import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import useWizard from '../hooks/useWizard';
import { WizardBody } from './WizardBody';
import { WizardHeader } from './WizardHeader';

type WizardProps = {
    subtitle: React.ReactNode;
};

const Wizard: React.FC<WizardProps> = (props) => {
    const wizardState = useAppSelector((state) => state.wizard);
    const wizardHook = useWizard({ autoOpenFirstUndoneStep: true });

    if (wizardHook.isAllDone()) {
        return <></>;
    }

    return (
        <s-section>
            <div className="hover-reveal-group flex flex-col gap-3">
                <WizardHeader subtitle={props.subtitle} steps={wizardState.steps || []} />

                <WizardBody
                    steps={wizardState.steps || []}
                    openStepName={wizardHook.openStepName}
                    isStepLocked={wizardHook.isStepLocked}
                    handleStepToggle={wizardHook.handleStepToggle}
                />
            </div>
        </s-section>
    );
};

export default Wizard;
